/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChangeTimezoneResponse {
    getFixupPrototypeFunction() { return ChangeTimezoneResponse.fixupPrototype; }

    static newInstance(model: Partial<ChangeTimezoneResponse>): ChangeTimezoneResponse {
        let obj = Object.assign(new ChangeTimezoneResponse(), model);
        ChangeTimezoneResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChangeTimezoneResponse>): ChangeTimezoneResponse {
        if (!model) return null;
        return ChangeTimezoneResponse.newInstance(<ChangeTimezoneResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChangeTimezoneResponse) {
        if (!obj) return;

        models.ChangeTimezoneResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChangeTimezoneResponse): boolean {
        Object.setPrototypeOf(obj, ChangeTimezoneResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.timezone) {
            models.ChangeTimezoneData.fixupPrototype(this.timezone);
        }
    }

    /**
     * Contains information about the timezone set for the user. Raw offset of the timezone. It means the amount of time in milliseconds to add to UTC to get standard time in the required time zone. Id of the Timezone such as Asia/Kolkata, Asia/Dubai and so on
     */
    timezone: models.ChangeTimezoneData;

    /**
     * ID of the user to whom the timezone is changed
     */
    user_id: string;

}
